// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V0qd","index":"styles_index__3yRa5"};